// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"bfde09e5","633":"9f055a98","816":"312141b8"}[chunkId] + ".chunk.js";
};